%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: 85449c2ea301fc54091646f096d9e4dc, type: 3}
  m_Name: DragonFireBreath
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 0}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  playOnCast: []
  castSound: {fileID: 0}
  castSoundVolume: 0.2
  soundBeforeChannel: {fileID: 8300000, guid: 7994f284bb25ca64fa21bb890b0e5e98, type: 3}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 8300000, guid: de004a7bae707c448878ca3b60ecc912, type: 3}
  afterChannelSoundDelay: 600
  animation: 19
  animationVariation: 2
  castDelay: 0
  animationSpeed: 1
  animationDuration: 2
  skipCooldownOnChannel: 0
  spellName: Emberstrike
  description: Breathe fire in front of you, permanently damaging the surface and
    damaging anyone who stands there.
  icon: {fileID: 2800000, guid: eaf4a0329e2305b4083c854a5db6e42d, type: 3}
  usableBy: 1c000000
  cooldown: 20
  castTime: 0
  isCastInterruptible: 0
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 1
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: 80cddad32b4f07e4bbf640afdccb32f4, type: 2}
  spellKey: 100102
  alwaysCastableSpell: 0
  luaScript: {fileID: 4900000, guid: d94c1ffe53785a440a7fe74cf732440a, type: 3}
